var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.css';
import { AnimateGroup } from 'react-animation';
import Header from './ItemComponents/Header';
import V2SandboxListItem from './ItemComponents/v2SandboxListItem';
import SandboxExtend from '../Modals/SandboxExtendModal';
import TerminateModal from '../Modals/TerminateModal';
import SandboxInvite from '../Modals/SandboxInviteModal';
import SandboxPushToAura from '../Modals/SandboxPushToAuraModal';
import { closeModal } from '../../actions/modalActions';
// @todo - make this stateless
var SandboxList = /** @class */ (function (_super) {
    __extends(SandboxList, _super);
    function SandboxList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            activeItems: [],
        };
        _this.handleItemClick = _this.handleItemClick.bind(_this);
        return _this;
    }
    SandboxList.prototype.handleItemClick = function (newIndex) {
        var activeItems = this.state.activeItems;
        var itemIndex = activeItems.indexOf(newIndex);
        var newActiveItems = __spreadArray([], activeItems, true);
        if (itemIndex > -1) {
            newActiveItems.splice(itemIndex, 1);
        }
        else {
            newActiveItems.push(newIndex);
        }
        this.setState({ activeItems: newActiveItems });
    };
    SandboxList.prototype.render = function () {
        var _this = this;
        var _a = this.props, user = _a.user, onCloseModal = _a.onCloseModal, activeModal = _a.activeModal, activeModalType = _a.activeModal.type;
        var activeItems = this.state.activeItems;
        // Sort sandboxes by createdAt (newest last)
        var sandboxes = this.props.sandboxes.sort(function (a, b) { return (a.createdAt < b.createdAt ? 1 : -1); });
        return (React.createElement("div", { className: "sandbox-list-table" },
            React.createElement(SandboxExtend, { open: activeModalType === 'extend', onClose: onCloseModal, clickedFrom: activeModal.data.clickedFrom }),
            React.createElement(TerminateModal, { open: activeModalType === 'terminate', onClose: onCloseModal }),
            React.createElement(SandboxInvite, { open: activeModalType === 'invite', onClose: onCloseModal }),
            React.createElement(SandboxPushToAura, { open: activeModalType === 'pushAura', onClose: onCloseModal }),
            React.createElement("div", { style: { cursor: 'pointer' } },
                React.createElement(Header, null),
                React.createElement(AnimateGroup, null, sandboxes.map(function (s, i) { return (React.createElement(V2SandboxListItem, { sandbox: s, key: s.ip || s.usecase, index: i, accessToken: user.accessToken, onItemClick: _this.handleItemClick, isActive: activeItems.indexOf(i) > -1 })); })))));
    };
    return SandboxList;
}(Component));
var mapStateToProps = function (state) { return ({
    accessToken: state.user.accessToken,
    extendSandboxHashKey: state.sandbox.extendSandboxHashKey,
    activeModal: state.activeModal,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    // true indicates that the model was closed with incomplete action
    onCloseModal: function () { return dispatch(closeModal(true)); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(SandboxList);
